import { render, staticRenderFns } from "./FirmwareCamsTable.vue?vue&type=template&id=504873bc"
import script from "./FirmwareCamsTable.vue?vue&type=script&lang=js"
export * from "./FirmwareCamsTable.vue?vue&type=script&lang=js"
import style0 from "./FirmwareCamsTable.vue?vue&type=style&index=0&id=504873bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VDataTable,VSheet,VSpacer,VTab,VTabs})
